{
  "version": 1,
  "asset_id": "4606cc70-07fd-48ba-85a7-6deb2b880e05",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/4606cc70-07fd-48ba-85a7-6deb2b880e05/wordmark-400.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/4606cc70-07fd-48ba-85a7-6deb2b880e05/wordmark-400.avif",
  "original_filename": "wordmark-400.avif",
  "size": 8246,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:19:06Z"
}
